import { Button, Tooltip } from '@indipia/ui-core'
import type { ShipRowButton } from '../../constants/ship.logic'

/** 행 오른쪽 버튼 1개. 기사 전화는 웹에서 항상 비활성(이유 Tooltip, tel: 링크 없음). 버튼이 없으면 자리만 유지. */
export function ShipActionButton({ button, loading, onClick }: {
  button: ShipRowButton
  loading: boolean
  onClick: () => void
}) {
  if (!button) return <div aria-hidden="true" className="min-w-24" />
  if (button.kind === 'CALL_DRIVER') {
    return (
      <div className="flex min-w-24 justify-end">
        <Tooltip tip={button.disabledReason}>
          <Button
            variant="secondary"
            size="sm"
            disabled
            aria-disabled="true"
            aria-label={`${button.label} (${button.disabledReason})`}
          >
            {button.label}
          </Button>
        </Tooltip>
      </div>
    )
  }
  const primary = button.kind === 'REQUEST_NOW' || button.kind === 'REREQUEST'
  return (
    <div className="flex min-w-24 justify-end">
      <Button variant={primary ? 'primary' : 'secondary'} size="sm" loading={loading} disabled={loading} onClick={onClick}>
        {button.label}
      </Button>
    </div>
  )
}
